module.exports = __webpack_public_path__ + "a3fb96124718ceea2a96c8dcc54a96f9.png";